import { gql } from '@apollo/client';

export const FORGET_PASSWORD_MUTATION = gql`
  mutation ForgetPassword($input: ForgetPasswordInput!) {
    forgetPassword(input: $input) {
      success
      type
      message
    }
  }
`;

